/**
 * 2026-06 (Laura): "Forza vista utente" toggle.
 *
 * Laura (admin/clinico) può attivare la modalità "vedo come una beta tester"
 * dalla pagina "Le mie scoperte" → vede esattamente la dashboard pulita,
 * senza approfondimenti clinici, senza badge tecnici, senza matrice profili.
 *
 * Salvato in localStorage così sopravvive ai reload.
 * IMPORTANTE: questo flag NON alza privilegi, li abbassa soltanto.
 * Non c'è rischio di leak: il backend resta autoritativo per i dati.
 */
const KEY = "revela_force_user_view";

export const isForcedUserView = () => {
  try {
    return localStorage.getItem(KEY) === "1";
  } catch {
    return false;
  }
};

export const setForcedUserView = (on) => {
  try {
    if (on) localStorage.setItem(KEY, "1");
    else localStorage.removeItem(KEY);
  } catch { /* ignore */ }
};

/**
 * Compone is_clinician reale + forced toggle.
 * Se Laura forza la vista utente, ritorna false anche se realmente è clinica.
 */
export const effectiveIsClinician = (realIsClinician) =>
  Boolean(realIsClinician) && !isForcedUserView();
